<section class="main-content content-limitation">
    <div class="content-left">
        <div>
            <button type="button" (click)="goToContact()" class="contact-me">{{'landing.contact-btn' | translate}}</button>

        </div>
        <div>
            <h2 class="">{{'landing.title' | translate}}</h2>
            <h1>Julian Herzfeld</h1>
        </div>
    </div>
    <div class="content-right">
        <img class="portrait" src="assets/img/personal-photos/profil-5.jpg" alt="portrait">
    </div>
    <div class="arrow-hover-container">
        <a href="#why-me"><img class="arrow-down" src="assets/img/icons/arrow-down.svg" alt=""></a>
    </div>

</section>